export default __webpack_public_path__ + "static/media/Sulfur.256.285f78b4.png";